export default {
      id: "numeric_arrow_down-usage",
      viewBox: "0 0 8 4",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#numeric_arrow_down",
      toString: function () {
        return this.url;
      }
    }